import { cn } from "~/lib/utils.ts";

import { ErrorProps, FormError } from ".";
import { Checkbox, Label } from "../ui";

interface Option {
  label: string;
  value: string;
}

interface Props {
  autoFocus?: boolean;
  label: string;
  required?: boolean;
  errors?: ErrorProps;
  value: string[] | any[];
  onChange: (value: string[]) => void;
  options: Option[];
}
export default function FormCheckInput({
  label,
  required,
  errors,
  onChange,
  value,
  options,
}: Props) {
  return (
    <div>
      <label className="space-y-1 capitalize">
        <div
          className={cn("text-base font-medium", {
            "text-danger-500": errors?.error,
          })}
        >
          {label} {required && <span className="text-danger-400">*</span>}
        </div>

        <div className="w-full">
          {options?.map((item: Option, key: number) => {
            return (
              <div className="flex items-center gap-2 space-y-1" key={key}>
                <Checkbox
                  className="h-4 w-4"
                  id={"option-" + (key + 1) + item?.value}
                  key={key}
                  checked={value?.includes(item?.value)}
                  onCheckedChange={(checked) => {
                    return checked
                      ? onChange([...value, item.value])
                      : onChange(
                          value?.filter((opt: string) => opt !== item.value),
                        );
                  }}
                />
                <Label
                  className="text-base text-neutral-500"
                  htmlFor={"option-" + (key + 1) + item?.value}
                >
                  <span className="text-base font-medium capitalize">
                    {item?.label}
                  </span>
                </Label>{" "}
              </div>
            );
          })}
        </div>

        <FormError error={errors?.error} message={errors?.message} />
      </label>
    </div>
  );
}
